import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_LARGE } from '~/constants';

import { unique } from '@vestigas/utils';

import { zodLedgerAccountSchema } from '../validations';

export { zodLedgerAccountSchema } from '../validations';

export const zodLedgerAccountsQueryParamsSchema = z.object({
  companyIds: z
    .array(z.uuid())
    .optional()
    .catch(undefined)
    .transform((data) =>
      Array.isArray(data) ? unique(data).filter(Boolean).toSorted() : data,
    ),
  costTypes: z
    .array(z.string())
    .optional()
    .catch(undefined)
    .transform((data) =>
      Array.isArray(data) ? unique(data).filter(Boolean).toSorted() : data,
    ),
  effectiveAsOf: z.iso.date().optional().catch(undefined),
  includeHistory: z.boolean().optional().catch(undefined),
  isCurrentlyEffective: z.boolean().optional().catch(undefined),
  isDeleted: z.boolean().optional().catch(undefined),
  limit: z.number().int().min(1).max(500).default(PAGINATION_PAGE_SIZE_LARGE),
  offset: z.number().int().min(0).default(0),
  searchString: z.string().trim().optional(),
});

export const zodLedgerAccountsResponseSchema = z.object({
  data: z.array(zodLedgerAccountSchema),
  hasNextPage: z.boolean().optional().default(false),
  paginatedCount: z.number().int().nonnegative(),
  totalCount: z.number().int().nonnegative().nullable().optional(),
});
